import type { RootState } from 'store'

export const getSort = (state: RootState) => state?.wines?.sorting
export const getPageInfo = (state: RootState) => state?.wines?.pageInfo ?? null
export const getLoading = (state: RootState) => state?.wines?.loading
export const getError = (state: RootState) => state?.wines?.error
export const getItems = (state: RootState) => state?.wines?.items
export const getQuery = (state: RootState) => state?.wines?.query ?? ''
export const getFilters = (state: RootState) => state?.wines?.filters ?? []
export const getTradeNameCount = (state: RootState) =>
  state?.wines?.tradeNameCount ?? 0
export const getCurrency = (state: RootState) => state?.wines?.currency ?? null
